import domReady from "@wordpress/dom-ready";

domReady(() => {
    const galleries = document.querySelectorAll(".wp-block-celebrate-suite-celebrate-directory-vendor-credits .celebrate-directory-credits-slideshow");

    galleries.forEach((gallery) => {
            const navigation = gallery.getAttribute('data-navigation') === 'true';
            const pagination = gallery.getAttribute('data-pagination') === 'true';
            const autoplay = gallery.getAttribute('data-autoplay') === 'true';
            const autoplaySpeed = parseInt(gallery.getAttribute('data-autoplay-speed')) || 4000;
            const groupCells = gallery.getAttribute('data-group-cells') === 'true';
            const centerMode = gallery.getAttribute('data-center-mode') === 'true';

            const flkty = new Flickity(gallery, {
                cellAlign: centerMode ? "center" : "left",
                imagesLoaded: true,
                contain: true,
                draggable: true,
                wrapAround: true,
                percentPosition: false,
                autoPlay: autoplay ? autoplaySpeed : false,
                prevNextButtons: navigation ? true : false,
                pageDots: pagination ? true : false,
                groupCells: groupCells,
                on: {
                    ready: function() {
                        gallery.style.opacity = 1;
                    }
                }
            });

    });
});

